import { ReactElement, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { TailSpin } from "react-loader-spinner";
import { getAuthToken, isAuthenticated } from '../utils/authSession';
import { getUserDashboard } from '../services/userService';
import { hasActiveSubscription as hasActiveSubscriptionStatus } from '../utils/subscriptionStatus';

export const PricingRoute = ({ children }: { children: ReactElement }): ReactElement => {
  const [isLoading, setIsLoading] = useState(isAuthenticated());
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);

  useEffect(() => {
    const checkSubscription = async () => {
      if (!isAuthenticated()) {
        setIsLoading(false);
        return;
      }

      const token = getAuthToken();
      if (!token) {
        setIsLoading(false);
        return;
      }

      try {
        const response = await getUserDashboard(token);
        setHasActiveSubscription(hasActiveSubscriptionStatus(response.data.subscriptions || []));
      } catch {
        setHasActiveSubscription(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkSubscription();
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#F4F5F7]">
        <TailSpin color="rgb(17,58,40)" height={80} width={80} />
      </div>
    );
  }

  if (hasActiveSubscription) {
    return <Navigate to="/library" replace />;
  }

  return children;
};
